module.exports = __webpack_public_path__ + "static/Meditation-f082edb1d63abd69dcb38f8ba320e05a.png";